import { MediaReport } from "../../constants/action-constants/MediaReportActionConstants";

export const openDownloadMediaReportForm = () => ({
  type: MediaReport.OPEN_DOWNLOAD_MEDIA_REPORT_MODAL,
});

export const closeDownloadMediaReportForm = () => ({
  type: MediaReport.CLOSE_DOWNLOAD_MEDIA_REPORT_MODAL,
});
